/**
 * Transforms integer to Si prefix number notation
 * @param  {Integer} number
 * @return {String} String in SI prefix format with 1 digit after the decimal point
 * @example
 * //returns 1.5k
 * numberSIPrefixFormatter(1500)
 * @example
 * //returns 1.2M
 * numberSIPrefixFormatter(123000000)
 */
const numberSIPrefixFormatter = number => {
  const lookup = {
    1: "",
    1e3: "k",
    1e6: "M",
    1e9: "G",
    1e12: "T",
    1e15: "P",
    1e18: "E"
  };
  const SIPrefixKey =
    Object.keys(lookup)
      .map(el => parseInt(el))
      .sort((a, b) => b - a)
      .find(el => el <= number) || 1;
  return `${parseFloat((number / SIPrefixKey).toFixed(1))}${lookup[SIPrefixKey]}`;
};
export default numberSIPrefixFormatter;
